import { MainAction } from '../../types/action-types';
import CommonActionsPage from '../common-actions-page/common-actions-page';
import TranslationsPage from '../../pages/translations/translations-page';
import OrderEligibilityPage from '../../pages/order-eligibility/order-eligibility-page';
import StoreFeaturesPage from '../../pages/store-features/store-features-page';
import RefundCalculatorPage from '../../pages/refund-calculator/refund-calculator-page';
import CreatePlatformStorePage from '../../pages/create-platform-store/create-platform-store-page';
import ProfilesPage from '../../pages/profiles/profiles-page';
import EmailValidationPage from '../../pages/email-validation/email-validation-page';
import CreateAdministratorsPage from '../../pages/create-administrators/create-administrators-page';

interface IActionRouterProps {
    selectedMainAction: MainAction;
}

const ActionRouter: React.FC<IActionRouterProps> = ({ selectedMainAction }) => {
    switch (selectedMainAction) {
        case MainAction.COMMON_ACTIONS:
            return <CommonActionsPage />;
        
        case MainAction.ADMIN_TRANSLATIONS:
            return <TranslationsPage />;
        
        case MainAction.ORDER_ELIGIBILITY:
            return <OrderEligibilityPage />;
        
        case MainAction.STORE_FEATURES:
            return <StoreFeaturesPage />;
        
        case MainAction.REFUND_CALCULATOR:
            return <RefundCalculatorPage />;
        
        case MainAction.CREATE_PLATFORM_STORE:
            return <CreatePlatformStorePage />;
        
        case MainAction.PROFILES:
            return <ProfilesPage />;
        
        case MainAction.EMAIL_VALIDATION:
            return <EmailValidationPage />;

        case MainAction.CREATE_ADMINISTRATORS:
            return <CreateAdministratorsPage />;
        
        default:
            return <CommonActionsPage />;
    }
};

export default ActionRouter;
